import { SelectOption } from '@Components/Selectors/Select'
import dayjs from 'dayjs'

export const getUsagePeriod = (usagePeriod: SelectOption) => {
    const thisUsagePeriod = dayjs(usagePeriod.value, 'MM-YYYY')
    const year = thisUsagePeriod.format('YYYY')
    const month = thisUsagePeriod.format('MM')

    return { year, month, thisUsagePeriod }
}
